
        var result = require("!!../../../../node_modules/css-loader/index.js!./group-budget-view.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/group-budget-view/group-budget-view.component.css
// module id = 595
// module chunks = 0